import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef, useCallback } from 'react';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/useFocusRing-CaK43saz.js';
import { u as useTileGroupContext } from '../TileGroupContext-CvSfRsxH.js';
import { D as DEFAULT_TILE_CONTEXT, T as TileContextProvider, a as TileControlContextProvider } from './TileContext-CI56_oXw.js';
import { C as Container } from './Tile.styles-CkHDNsw_.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const Tile = /*#__PURE__*/forwardRef(({
  direction: tileDirection,
  disabled: tileDisabled = false,
  label,
  onChange,
  selected: tileSelected = false,
  taktId,
  taktValue,
  value,
  children,
  ...restProps
}, ref) => {
  const {
    onSelect,
    selectedValues,
    direction: tileGroupDirection,
    disabled: tileGroupDisabled
  } = useTileGroupContext();
  const selected = (selectedValues !== null && selectedValues !== void 0 ? selectedValues : []).findIndex(selectedValue => selectedValue === value) > -1 || tileSelected || DEFAULT_TILE_CONTEXT.selected;
  const direction = tileGroupDirection || tileDirection || DEFAULT_TILE_CONTEXT.direction;
  const disabled = tileGroupDisabled || tileDisabled || DEFAULT_TILE_CONTEXT.disabled;
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  const handleChange = useCallback(event => {
    if (onSelect) {
      onSelect(value, event);
    }
    if (onChange) {
      onChange(event);
    }
  }, [onChange, onSelect, value]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('tile')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(Container, _extends({
    $checked: selected,
    $disabled: disabled,
    $direction: direction,
    $focusVisible: isFocusVisible
  }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TileContextProvider, {
    disabled: disabled,
    selected: selected,
    direction: direction
  }, /*#__PURE__*/React__default.createElement(TileControlContextProvider, {
    focusProps: focusProps,
    label: label,
    onChange: handleChange,
    value: value,
    innerRef: ref,
    restProps: restProps
  }, children))));
});

export { Tile as T };
//# sourceMappingURL=Tile-BIUtHG5p.js.map
